export const emailInputDataCy = 'email-input-data';
export const passwordInputDataCy = 'password-input-data';
export const continueButtonDataCy = 'continue-button-data';
export const employeeIdInputDataCy = 'employee-id-input-data';
